import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "2888",
  height: "1327",
  viewBox: "0 0 2888 1327",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2171.5 1L2884.5 214L1 1326",
      stroke: "url(#paint0_linear_10_466)",
      "stroke-opacity": "0.32",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "paint0_linear_10_466",
        x1: "773.759",
        y1: "-1362.65",
        x2: "3921.94",
        y2: "1759.43",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", {
          "stop-color": "#001A78",
          "stop-opacity": "0"
        }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#596294"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }